import { Sparkles } from 'lucide-react';
import { qrImageUrl } from '../hooks/usePersonalQrCode';

/**
 * SitePass (Jaime 2026-10-17): PRIVATE full-screen route (/home/site-pass)
 * showing a STATIC QR that encodes exactly 'https://vecindus.com' — no
 * header, no tab bar, no navigation chrome. Same visual language as
 * /home/access-pass (43a4c6d): deep-teal brand gradient backdrop, centered
 * white rounded card. Reuses the app's existing qrImageUrl utility (qrserver)
 * — no new dependency. Static content, no rotation, no fake data.
 */
export default function SitePass() {
  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-6 overflow-hidden"
      style={{
        background: 'linear-gradient(160deg, var(--v-teal-800) 0%, var(--v-teal-900) 60%, #021b1e 100%)',
      }}
    >
      <div className="flex items-center gap-2 text-[var(--v-teal-200)]">
        <Sparkles className="w-5 h-5" />
        <span className="text-sm font-medium tracking-wide uppercase">Vecindus</span>
      </div>

      <h1 className="text-2xl font-semibold text-white text-center px-8">
        Pruébalo gratis en 1 minuto
      </h1>

      <div className="p-5 rounded-3xl bg-white/95 shadow-2xl">
        <img
          src={qrImageUrl('https://vecindus.com', 288)}
          width={288}
          height={288}
          alt="QR a vecindus.com"
        />
      </div>

      <p className="text-xs text-[var(--v-teal-200)]/70">vecindus.com</p>
    </div>
  );
}
